export default __webpack_public_path__ + "static/En_ELIB_EzyMedical_ClaimGuide-1b34fafb8f18cba9dd8d4a53d294cb20.pdf";